import { PayloadAction } from '@reduxjs/toolkit'
import axios, { AxiosResponse } from 'axios'
import { put, call, takeEvery, select } from 'redux-saga/effects'
import {
  fetchCaseRequest,
  fetchCaseSuccess,
  fetchCaseError,
  fetchCaseSilent,
  updateCaseFailedDueToConflict,
} from '.'
import { IBoardCaseDetailModel } from '../../models/BoardCase'
import { getCase } from '../../api/boardCases.api'
import { getBoardCase } from './selectors'

function* fetchCase({ payload }: PayloadAction<string>) {
  try {
    const caseResponse: AxiosResponse<IBoardCaseDetailModel> = yield call(
      getCase,
      payload
    )

    yield put(fetchCaseSuccess(caseResponse.data))
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e)
      yield put(fetchCaseError(e))
    }
  }
}

function* fetchSilent({ payload }: PayloadAction<string>) {
  // We dont actually know whether we get the id or not.
  // We should because we do a "includes" on the id into the pathname though.
  if (!payload) return

  const currentCase: { data: IBoardCaseDetailModel | null } =
    yield select(getBoardCase)

  if (!currentCase) return

  try {
    const res: AxiosResponse<IBoardCaseDetailModel> = yield call(
      getCase,
      payload
    )

    const isOnEditPage = window.location.pathname.includes(`endre`)
    const hasSameLastUpdated =
      res.data.lastUpdated === currentCase.data?.lastUpdated

    // If its not the same lastUpdated
    // We know the user is not the last updating person
    if (isOnEditPage && !hasSameLastUpdated) {
      yield put(updateCaseFailedDueToConflict())
      return
    }

    if (!isOnEditPage) {
      yield put(fetchCaseSuccess(res.data))
    }
  } catch (e) {
    // Avoid silently giving the page an error that the user did not cause
    // So we do not use the fetch case error
    console.log(e)
  }
}

function* caseSaga() {
  yield takeEvery(fetchCaseRequest, fetchCase)
  yield takeEvery(fetchCaseSilent, fetchSilent)
}

export default caseSaga
